(function () {
  const banner = document.querySelector('[data-cookie-consent]');

  if (!banner) {
    return;
  }

  const storageKey = 'thoughtfully_cookie_consent_v1';
  const preferencesPanel = banner.querySelector('[data-cookie-consent-preferences]');
  const acceptButton = banner.querySelector('[data-cookie-consent-accept]');
  const rejectButton = banner.querySelector('[data-cookie-consent-reject]');
  const customizeButton = banner.querySelector('[data-cookie-consent-customize]');
  const saveButton = banner.querySelector('[data-cookie-consent-save]');
  const inputs = {
    preferences: banner.querySelector('input[name="preferences"]'),
    analytics: banner.querySelector('input[name="analytics"]'),
    marketing: banner.querySelector('input[name="marketing"]'),
    saleOfDataOptOut: banner.querySelector('input[name="sale_of_data_opt_out"]')
  };

  function getCustomerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function hasStoredConsent() {
    try {
      return window.localStorage.getItem(storageKey) !== null;
    } catch (error) {
      return false;
    }
  }

  function storeConsent(consent) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify({
        consent: consent,
        savedAt: new Date().toISOString()
      }));
    } catch (error) {
      // Shopify's consent cookie is the source of truth when available.
    }
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function showBanner() {
    banner.hidden = false;
  }

  function showPreferences() {
    preferencesPanel.hidden = false;
    saveButton.classList.remove('hidden');
    customizeButton.classList.add('hidden');
    showBanner();
  }

  function normalizeConsent(consent) {
    return {
      preferences: Boolean(consent.preferences),
      analytics: Boolean(consent.analytics),
      marketing: Boolean(consent.marketing),
      sale_of_data: consent.sale_of_data !== false
    };
  }

  function setConsent(consent) {
    const normalizedConsent = normalizeConsent(consent);
    const customerPrivacy = getCustomerPrivacy();

    storeConsent(normalizedConsent);

    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') {
      hideBanner();
      return;
    }

    customerPrivacy.setTrackingConsent(normalizedConsent, hideBanner);
  }

  function shouldShowBanner() {
    const customerPrivacy = getCustomerPrivacy();

    if (customerPrivacy && typeof customerPrivacy.shouldShowBanner === 'function') {
      return customerPrivacy.shouldShowBanner();
    }

    return !hasStoredConsent();
  }

  function initializeFromCurrentConsent() {
    const customerPrivacy = getCustomerPrivacy();

    if (!customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function') {
      return;
    }

    const currentConsent = customerPrivacy.currentVisitorConsent();

    if (!currentConsent) {
      return;
    }

    inputs.preferences.checked = currentConsent.preferences === 'yes' || currentConsent.preferences === true;
    inputs.analytics.checked = currentConsent.analytics === 'yes' || currentConsent.analytics === true;
    inputs.marketing.checked = currentConsent.marketing === 'yes' || currentConsent.marketing === true;
    inputs.saleOfDataOptOut.checked = currentConsent.sale_of_data === 'no' || currentConsent.sale_of_data === false;
  }

  function initialize() {
    initializeFromCurrentConsent();

    if (window.location.hash === '#cookie-preferences') {
      showPreferences();
      return;
    }

    if (shouldShowBanner()) {
      showBanner();
    }
  }

  acceptButton.addEventListener('click', function () {
    setConsent({
      preferences: true,
      analytics: true,
      marketing: true,
      sale_of_data: true
    });
  });

  rejectButton.addEventListener('click', function () {
    setConsent({
      preferences: false,
      analytics: false,
      marketing: false,
      sale_of_data: false
    });
  });

  customizeButton.addEventListener('click', function () {
    showPreferences();
  });

  saveButton.addEventListener('click', function () {
    setConsent({
      preferences: inputs.preferences.checked,
      analytics: inputs.analytics.checked,
      marketing: inputs.marketing.checked,
      sale_of_data: !inputs.saleOfDataOptOut.checked
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash === '#cookie-preferences') {
      showPreferences();
    }
  });
})();
